<template>
  <div class="checkbox-list-container">
    <div 
      v-for="option in options" 
      :key="option.value"
      class="checkbox-item"
    >
      <div 
        class="checkbox-button"
        :class="{ 'active': isSelected(option.value) }"
        @click="toggleSelection(option.value)"
      >
        <span class="checkbox-label">{{ option.label }}</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'FormToggleButton',
  props: {
    modelValue: {
      type: Array,
      default: () => []
    },
    options: {
      type: Array,
      required: true,
    }
  },
  emits: ['update:modelValue'],
  methods: {
    isSelected(value) {
      return this.modelValue.includes(value)
    },
    toggleSelection(value) {
      const selected = [...this.modelValue]
      const index = selected.indexOf(value)
      
      if (index === -1) {
        selected.push(value)
      } else {
        selected.splice(index, 1)
      }
      
      this.$emit('update:modelValue', selected)
    }
  }
}
</script>

<style scoped>
.checkbox-list-container {
  display: flex;
  flex-direction: column;
  gap: 10px;
  max-width: 390px;
}

.checkbox-item {
  width: 100%;
}

.checkbox-button {
  width: 100%;
  padding: 8px 15px;
  border: 2px solid #195983;
  border-radius: 4px;
  background-color: #FFF;
  color: #000;
  cursor: pointer;
  transition: all 0.3s ease;
  box-sizing: border-box;
}

.checkbox-button:hover {
  background-color: #e6f0f5;
}

.checkbox-button.active {
  background-color: #195983;
  color: #FFF;
}

.checkbox-label {
  font-weight: bold;
}
</style>
